/**
 * Article type
 * DOC: https://schema.org/Article
 */

export const article = ({
  url,
  articleBody,
  articleSection,
  authorId,
  editorId,
  headline,
  description,
  datePublished,
  dateModified,
  publisherId,
  images,
  copyrightYear,
  subjectOfId,
  timeRequired
}) => {
  if (!url || typeof url === 'undefined') {
    throw new Error('url argument is required');
  }
  const imageItem = ({
    id,
    url,
    name
  }) => `{
    "@type": "ImageObject",
    "@id": "${id}",
    "url": "${url}",
    "name": "${name}"
  }`;
  const result = [];
  result.push('"@type": "Article"');
  result.push(`"@id": "${url}#article"`);
  result.push(`"isPartOf": { "@type": "WebPage", "@id": "${url}#webpage"}`);
  result.push(`"mainEntityOfPage": { "@id": "${url}#webpage" }`);
  if (subjectOfId) {
    result.push(`"subjectOf": { "@id": "${subjectOfId}"}`);
  }
  if (timeRequired) {
    result.push(`"timeRequired": "${timeRequired}"`);
  }
  if (articleBody) {
    result.push(`"articleBody": ${articleBody}`);
  }
  if (authorId) {
    result.push(`"author": { "@id": "${authorId}#personAuthor" }`);
  }
  if (editorId) {
    result.push(`"editor": { "@id": "${editorId}#personEditor" }`);
  }
  if (headline) {
    result.push(`"headline": "${headline}"`);
  }
  if (description) {
    result.push(`"description": "${description}"`);
  }
  if (datePublished) {
    result.push(`"datePublished": "${datePublished}"`);
  }
  if (dateModified) {
    result.push(`"dateModified": "${dateModified}"`);
  }
  if (publisherId) {
    result.push(`"publisher": { "@id": "${publisherId}#organization" }`);
    result.push(`"copyrightHolder": { "@id": "${publisherId}#organization" }`);
  }
  if (images && images.length > 0) {
    result.push(`"image": [
      ${images.map(args => imageItem(args)).join(',')}
    ]`);
  }
  if (articleSection) {
    result.push(`"articleSection": "${articleSection}"`);
  }
  if (copyrightYear) {
    result.push(`"copyrightYear": "${copyrightYear}"`);
  }
  return `{${result.filter(item => item).join(',')}}`;
};